import React from 'react';
import { connect } from 'react-redux';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import Page from '../../../page.jsx';
import ReviewLink from '../../../review/reviewLink.jsx';
import FeedbackLink, { SELLER_SAD } from '../../../feedbackLink.jsx';

function getHeading(payment) {
    return payment.performedBy === 'SELLER'
        ? 'Du har hevet kjøpet'
        : 'Kjøpet er hevet';
}

const PaymentRevertedDetails = ({ partner, payment }) => (
    <Page heading={getHeading(payment)}>
        <div>
            <div className="r-pbl">
                <p>{partner.name} får nå tilbake pengene sine.</p>
            </div>

            <div className="r-phl">
                <ReviewLink partner={partner} />
                <FeedbackLink type={SELLER_SAD} />
            </div>
        </div>
    </Page>
);

PaymentRevertedDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
        payment: state.payment.data,
    };
}

export default connect(mapStateToProps)(PaymentRevertedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/statusDetails/paymentRevertedDetails.jsx